$('.our-story-home .play-video').on('click', function () {
    $(this).next('video').trigger('play').prop('controls',true);
    $(this).hide();
});